import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const navigation = [
    { name: "Home", href: "/" },
    { name: "Über uns", href: "/ueber-uns" },
    { name: "Leistungen", href: "/leistungen" },
    { name: "Kontakt", href: "/kontakt" },
];

export const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Close mobile menu on navigation link click
    const handleNavClick = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ease-premium ${
                isScrolled
                    ? "bg-background/95 backdrop-blur-sm border-b border-border"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="flex items-center justify-between h-20 lg:h-24">
                    {/* Logo */}
                    <Link to="/" className="flex items-center group">
                        <img
                            src="/images/logo.png"
                            alt="Steuerberatung Ruberto"
                            className="h-12 lg:h-[68px] w-auto"
                        />
                    </Link>

                    {/* Desktop Navigation */}
                    <nav className="hidden lg:flex items-center space-x-12">
                        {navigation.map((item) => (
                            <Link
                                key={item.name}
                                to={item.href}
                                className={`relative font-sans text-sm tracking-premium uppercase transition-colors duration-300 ${
                                    location.pathname === item.href
                                        ? "text-gold"
                                        : "text-muted-foreground hover:text-foreground"
                                }`}
                            >
                                {item.name}
                                {location.pathname === item.href && (
                                    <span className="absolute -bottom-1 left-0 w-full h-px bg-gold opacity-60" />
                                )}
                            </Link>
                        ))}
                    </nav>

                    {/* Mobile Menu Button */}
                    <Button
                        variant="ghost"
                        size="icon"
                        className="lg:hidden text-foreground hover:text-gold hover:bg-transparent"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        {isMobileMenuOpen ? (
                            <X className="h-6 w-6" />
                        ) : (
                            <Menu className="h-6 w-6" />
                        )}
                    </Button>
                </div>

                {/* Mobile Navigation */}
                {isMobileMenuOpen && (
                    <div className="lg:hidden border-t border-border bg-background/98 backdrop-blur-sm">
                        <nav className="py-8 space-y-6">
                            {navigation.map((item) => (
                                <Link
                                    key={item.name}
                                    to={item.href}
                                    onClick={handleNavClick}
                                    className={`block font-sans text-sm tracking-premium uppercase transition-colors duration-300 ${
                                        location.pathname === item.href
                                            ? "text-gold"
                                            : "text-muted-foreground hover:text-foreground"
                                    }`}
                                >
                                    {item.name}
                                </Link>
                            ))}
                        </nav>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
